/**
 * Static client-side configuration.
 *
 * Login page: developer branding (Heer IT Solutions).
 * App company name + logo: loaded from GET /api/branding (R2 logo key in deploy/.env).
 */
const rawApiVersion = (process.env.REACT_APP_API_VERSION || '').trim().toLowerCase();

export const clientConfig = {
  /** Shown on login page only */
  loginCompanyName: 'HEER IT SOLUTIONS',
  loginLogoUrl: null,
  developerName: 'Heer It Solutions',

  /** Used only until /api/branding loads or if the request fails */
  fallbackCompanyName: 'SHREE LAXMIKANT TEXTILE',

  apiBaseUrl: (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080').replace(/\/+$/, ''),
  apiVersion: rawApiVersion === 'v2' ? 'v2' : '',
};
